import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { addMonths, startOfMonth, subMonths } from 'date-fns';
import { useMemo } from 'react';
import { useAuth } from '@/app/_auth/useAuth';
import { useTRPC } from '@/app/_trpc/config';
export function useOrganizerAvailability(selectedDay) {
  const $ = _c(37);
  const {
    user
  } = useAuth();
  const userEmail = user?.email ?? "";
  const trpc = useTRPC();
  let t0;
  let t1;
  let t2;
  if ($[0] !== selectedDay) {
    const current = startOfMonth(selectedDay);
    t0 = subMonths(current, 1);
    t1 = current;
    t2 = addMonths(current, 1);
    $[0] = selectedDay;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
  } else {
    t0 = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = {
      prev: t0,
      current: t1,
      next: t2
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const monthsToFetch = t3;
  let t4;
  if ($[8] !== trpc.phoneCallBooking.getOrginizerAvailabilityForMonthByEmail || $[9] !== userEmail) {
    t4 = date => trpc.phoneCallBooking.getOrginizerAvailabilityForMonthByEmail.queryOptions({
      email: userEmail,
      date
    }, {
      enabled: !!userEmail
    });
    $[8] = trpc.phoneCallBooking.getOrginizerAvailabilityForMonthByEmail;
    $[9] = userEmail;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const availabilityForMonthQueryOptions = t4;
  let t5;
  if ($[11] !== availabilityForMonthQueryOptions || $[12] !== monthsToFetch.prev) {
    t5 = availabilityForMonthQueryOptions(monthsToFetch.prev);
    $[11] = availabilityForMonthQueryOptions;
    $[12] = monthsToFetch.prev;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const queryPrev = useQuery(t5);
  let t6;
  if ($[14] !== availabilityForMonthQueryOptions || $[15] !== monthsToFetch.current) {
    t6 = availabilityForMonthQueryOptions(monthsToFetch.current);
    $[14] = availabilityForMonthQueryOptions;
    $[15] = monthsToFetch.current;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const queryCurrent = useQuery(t6);
  let t7;
  if ($[17] !== availabilityForMonthQueryOptions || $[18] !== monthsToFetch.next) {
    t7 = availabilityForMonthQueryOptions(monthsToFetch.next);
    $[17] = availabilityForMonthQueryOptions;
    $[18] = monthsToFetch.next;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const queryNext = useQuery(t7);
  let t8;
  if ($[20] !== queryCurrent || $[21] !== queryNext || $[22] !== queryPrev) {
    t8 = [queryPrev, queryCurrent, queryNext];
    $[20] = queryCurrent;
    $[21] = queryNext;
    $[22] = queryPrev;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const queries = t8;
  let t9;
  if ($[24] !== queryPrev.data?.events) {
    t9 = queryPrev.data?.events ?? [];
    $[24] = queryPrev.data?.events;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== queryCurrent.data?.events) {
    t10 = queryCurrent.data?.events ?? [];
    $[26] = queryCurrent.data?.events;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== queryNext.data?.events) {
    t11 = queryNext.data?.events ?? [];
    $[28] = queryNext.data?.events;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t10 || $[31] !== t11 || $[32] !== t9) {
    t12 = {
      events: [...t9, ...t10, ...t11]
    };
    $[30] = t10;
    $[31] = t11;
    $[32] = t9;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  const combinedData = t12;
  let t13;
  if ($[34] !== combinedData || $[35] !== queries) {
    t13 = {
      queries,
      combinedData
    };
    $[34] = combinedData;
    $[35] = queries;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
}